if (!customElements.get('section-product-recommendations')) {
    class TG_SectionProductRecommendation extends HTMLElement {
        constructor() {
        super();
        }

        connectedCallback() {
            this.element = this;
            this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

            if (Shopify.designMode) {
                setTimeout(this._loadRecommendations.bind(this), 1000);
            }else{
                this._loadRecommendations();
            }
        }


        _loadRecommendations() {
            var _this = this;

            var url = window.routes.productRecommendationsUrl + '?section_id=' + this.options['sectionId'] + '&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsCount'] + '&intent=' + this.options['recommendationsType'];

            return fetch(url).then(function (response) {
            return response.text().then(function (content) {
                var container = document.createElement('div');
                container.innerHTML = content;

                //has recommend product
                if(container.querySelector('.ProductList--hasProduct')){
                _this.element.querySelector('.ProductRecommendations__Body').innerHTML = container.querySelector('.ProductRecommendations__Body').innerHTML;

                if (_this.options['layout'] === 'carousel' ) {
                    // _this.carousel = new themegoal.components.Carousel(_this.element.querySelector('[data-flickity-config]'));
                }
                }else{
                // Show the section
                _this.element.style.display = 'none';
                }

                const swiper = document.querySelector(".ProductRecommendations__Body");
                const sliderRecomends = new Swiper(swiper, {
                    slidesPerView: "auto",
                    grabCursor: true,
                    spaceBetween: 12,
                    allowTouchMove: true,
                    mousewheel: {
                        forceToAxis: true
                    },
                });

                setTimeout(() => {
                    document.querySelectorAll(".ProductCard").forEach((productCard, index) => {
                        setTimeout(() => {
                            const swiper = productCard.querySelector(".swiper");
                            const swiperPagination = productCard.querySelector(".swiper-pagination");
                            const swiperButtonNext = productCard.querySelector(".swiper-button-next");
                            const swiperButtonPrev = productCard.querySelector(".swiper-button-prev");
                            const slider = new Swiper(swiper, {
                            slidesPerView: 1,
                            touchReleaseOnEdges: true,
                            spaceBetween: 12,
                            mousewheel: {
                                forceToAxis: true
                            },
                            pagination: {
                                el: swiperPagination,
                                clickable: true,
                            },
                            navigation: {
                                nextEl: swiperButtonNext,
                                prevEl: swiperButtonPrev,
                            },
                            on: {
                                touchStart() {
                                    sliderRecomends.allowTouchMove = false;
                                },
                                touchEnd() {
                                    sliderRecomends.allowTouchMove = true;
                                },
                            },
                            });
                        }, index*100);

                        setTimeout(() => {
                            productCard.classList.add("show-slider-component");
                            setTimeout(() => {
                                productCard.classList.remove("show-slider-component");
                            }, 400);
                        }, index*100 + 2000);
                    });
                }, 100);

                setMaxHeightForElements('.shopify-section--product-recommendations .ProductCard__Info', true);

                window.addEventListener('resize', () => {
                    setMaxHeightForElements('.shopify-section--product-recommendations .ProductCard__Info', true);
                });

                });
            });
        }
    }

    customElements.define('section-product-recommendations', TG_SectionProductRecommendation);
}